
	import Component from 'vue-class-component'
	import moduleStore from './store/chargeBean';
	import Vue from 'vue';
	import PageState from './store/state';
	import {getQueryString} from "@/utils/location";
	import {toast} from "@/utils/util";
	import {judgeDeviceType} from "@/utils/device";
	import {Watch} from "vue-property-decorator";


	/**components**/
	@Component({})
	@moduleStore.initVuex({
		mutationNames:moduleStore.mutationNames,
		actionNames:moduleStore.actionNames
	})
	export default class exchangeBeanPage extends Vue implements IvuePage<PageState>{
		state = new PageState();
		self:Vue = this;
		siginText = require('/public/images/welfare/charge_text.png');
		box = require('/public/images/welfare/box.png');
		bean = require('/public/images/welfare/bean.png');
		texture = require('/public/images/welfare/texture.png');
		beanGift=require('/public/images/welfare/bean_gift.png');
		beanHeader=require('/public/images/welfare/bean_header.png');
		changePop=require('/public/images/welfare/changePop.png');
		voiceCloseIcon=require('/public/images/welfare/voice_filter_close.png');
		iconCheck=require('/public/images/welfare/icon_check.png');
		isIOS = judgeDeviceType.isIOS
		isMinip: Boolean = judgeDeviceType.isMinip
		ww_token:String='';

		totalCount:any=0;
		pageIndex:any=0;
		configLists = [];
		nopage:Number=0;
		loading:Boolean=false;
		isVisible:Boolean=false;
		finished:Boolean=false;
		showPop:Boolean=false;
		popItem:any={};
		showDetail: boolean = false
// 声音弹窗
		showVoice:Boolean=false;
		loadingv:Boolean=false;
		finishedv:Boolean=false;
		pageNum:any=0;
		pageSizev:any=12;
		keyword:any='';
		info:any={};
		voiceLists=[];
		storeId:any=[];
		exchangeConfigId:any=1;
		selectedPerson:any=[];
		giftId:any=[];
		packageIdList:any=[];
		@Watch("showVoice")//弹窗选中的发音人置空
		changeSelectedPerson() {
			this.showVoice==false?this.selectedPerson.length = 0 :'';
		}

		created(moduleData:IinjectDatas) {
			this.state = <PageState>moduleData.state;
		}
		mounted(moduleData:IinjectDatas){
			this.getAmounts();

		}
		getAmounts(){
			this.$http("getAmount",{}).then((response:any)=>{
				this.totalCount=(response.data/100).toFixed(2);
				this.selectedPerson.length=0;
				this.upLoadData();
			}).catch((ex:any)=>{
				console.log(ex)
			})
		}
		getGiftsLists(){
			this.loading=true;
			this.$http("getGiftsList",{}).then(res => {
				this.loading=false;
				this.finished = true;
				this.configLists= res.data;
			})
		};
		upLoadData(){
			this.pageIndex++;
			this.loading = true;
			this.finished = false;
			this.configLists.length=0;
			this.getGiftsLists();
		}
		toPath(path){
			this.$router.push({path:path,query:{wwid:getQueryString('wwid')}})
		}
		//点击领取
		goReceive(item){
			this.giftId=item.id;
			if(item.needSpeaker){
				this.info=item.speakerGift;
				this.toGetVoice(item);
			}else{
				this.receiveSure();
			}
		}
		//领取声音
		toGetVoice(item){
			this.showVoice=true;
			this.pageNum=1;
			this.loadingv = true;
			this.finishedv = false;
			this.voiceLists=[];
			this.keyword='';
			this.getVoiceLists();
		}
		//获取声音列表
		getVoiceLists(){
			let param={
				keyword:this.keyword,
				pageSize:this.pageSizev,
				pageNum:this.pageNum,
			}
			this.loadingv=true;
			this.$http("getVoiceList",param).then(res => {
				this.loadingv=false;
				if(res.code==200){
					let nopage=res.data.selectedSpeakerVOList.length;
					res.data.selectedSpeakerVOList.forEach(r=>{
						r.checked=false;
					})
					this.finishedv = false;
					if( nopage>0){
						this.voiceLists= [...this.voiceLists,...res.data.selectedSpeakerVOList];
						//搜索之后记住之前选中的发音人
						this.voiceLists.forEach(v1=>{
							this.selectedPerson.forEach(v2=>{
								if(v1.packageId==v2.packageId){
									v1.checked=true;
								}
							})
						})
					}else{
						this.finishedv = true;
					}
				}else{
					toast(res.message)
					this.finishedv=true
					this.loadingv=false;
					this.pageSizev = 0
				}
			})
		}
		//加载更多发音人
		upLoadDataVoice(){
			this.pageNum++;
			this.loadingv = true;
			this.finishedv = false;
			this.getVoiceLists();
		}
		//选中发音人
		//选中发音人
		chosedVoice(item,index){
			if(this.selectedPerson.length+1 > this.info.speakerNum&&!item.checked){
				return this.$toast("只能选择"+this.info.speakerNum+'个发音人')
			}

			this.voiceLists.forEach((res,key)=>{
				if(key==index){
					res.checked=!item.checked;
					//选中
					if(item.checked){
						this.selectedPerson.push({
							name:item.name,
							packageId:item.packageId
						})
					}else{
						this.selectedPerson=this.selectedPerson.filter(res=> res.packageId!=item.packageId);
					}
				}
			})
			this.$set(this.voiceLists,index,this.voiceLists[index]);
		}
		//搜索发音人
		toSearch(){
			this.pageNum=1;
			this.loadingv = true;
			this.finishedv = false;
			this.voiceLists=[];
			this.getVoiceLists();
		}
		//确认领取
		receiveSure(){
			this.packageIdList=this.selectedPerson.map(res=>res.packageId)
			this.exchangeHandle();
		}

		exchangeHandle(){
			let param={
				// wwid:getQueryString('wwid'),
				giftId:this.giftId,
				packageIdList:this.packageIdList.join(),
			}
			console.log(param)
			this.$http("receive",param).then(res => {
                 if(res.code===200&&res.data.result){
					 toast('领取成功');
				     this.showVoice=false;
					 this.getAmounts();
				 }else{
					 toast(res.message);
				 }
			})

		}
		goCharge(){
			if (this.isMinip) {//小程序
				this.ww_token= getQueryString("ww_token")||localStorage.getItem("ww_token");
				this.$navigateTo({
					url: `/pages/recharge-vip/recharge-vip?fromBtn=chargeBean&ww_token=${this.ww_token}`
				})
			} else {
				let switchToVipPage=(<any>window).switchToVipPage;
				switchToVipPage.postMessage("");
			}
		}
	}